import * as ethers from 'ethers'

export enum PaymasterTransactionType {
  OracleUSDC = 'oracle-usdc',
  PythOracleUsdc = 'pyth-usdc',
  USDCFixed = 'usdc-fixed',
  Gasless = 'gasless'
}

export enum PaymasterFlow {
  ApprovalBased = 'ApprovalBased',
  General = 'General'
}

// export const ONE_TOKEN_18_DECIMALS = 1n
export const ONE_TOKEN_18_DECIMALS = ethers.BigNumber.from(`1000000000000000000`)
